import { API_URL, CMS_URL, numberWithCommas, THEME_COLOR } from '../../constant';
import React, {useEffect, useState} from 'react';
import SlidingPane from 'react-sliding-pane';
import "react-sliding-pane/dist/react-sliding-pane.css";
import toast, { Toaster } from 'react-hot-toast';
import M from "materialize-css";

import banner2 from "../../images/bst_banner.jpg"
import deliver from "../../images/icon/deliveryman.svg"
import Warehouse from "./Warehouse";
import "./Warehouse.css";
import { useLocalStorage } from '../../useLocalStorage';

let ItemInfo = (props)=>{
    
    const [token, setToken] = useLocalStorage("token", "");
    const [wh, setWh] = useLocalStorage("wh", "");
    const [itemPrice, setItemPrice] = useState(0);
    const [warehouse, setWarehouse] = useState({})
    const [warehouses, setWarehouses] = useState({})
    const [address, setAddress] = useState({})
    const [isOpenAddress, setIsOpenAddress] = useState(false);
    const [isOpenWarehouse, setIsOpenWarehouse] = useState(false);
    const [qty, setQty] = useState(1);
    const [shippingMethod, setShippingMethod] = useState('PICKUP');
    const [availStockConfig, setAvailStockConfig] = useState({});

    const changeIsOpenQty = (val) => {
        props.changeIsOpenQty(val)
    }
    
    function changeIsOpenWarehouse(val){
        setIsOpenWarehouse(val)
    }

    function getAvailableStock(){
        
        var urlencoded = new URLSearchParams();
        urlencoded.append("type", "Ecommerce_Available_Stock");
        urlencoded.append("row", 1);

        var requestOptions = {
            method: 'POST',
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/configuration`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function initConfig(){
        let response = await getAvailableStock();
        if(response && response.status == 200){
            setAvailStockConfig(response.data)
        }
    }

    function getStock(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("x-wh", wh);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/stock/${props.itemunitid}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function initWarehouse(){
        let data = await getStock();
        if(data){
            if(data.status == 200){
                data = data.data;
                setWarehouses(data)
                if(data && data.length >0){
                    setWarehouse({
                        ID: data[0].WarehouseID,
                        CompanyID: data[0].CompanyID,
                        BranchID: data[0].BranchID,
                        WarehouseID: data[0].WarehouseID,
                        Name : data[0].WarehouseName,  
                        Stock : data[0].QtyEnd,  
                        CityID: data[0].CityOngkirID,
                        CityName : data[0].CityName,
                        ProvinceID: data[0].ProvinceID,
                        ProvinceName: data[0].ProvinceName,
                        Address : data[0].WarehouseAddress,  
                    })
                }else{
                    setWarehouse({
                        ID: 0,
                        Name: "",
                        Stock: 0,
                    })
                }
            }
            else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
    }

    async function decrementQty(){
        await setQty(parseInt(qty) - 1);
        if(qty < 2){
            setQty(1);
        }
        // props.prices.forEach(element => {
        //     let tqty = qty -1;
        //     if(tqty >= element.Qty){
        //         setItemPrice(element.Price);
        //     }
        // });
    }

    function incrementQty(){
        setQty(parseInt(qty) + 1);
        // props.prices.forEach(element => {
        //     let tqty = qty + 1;
        //     if(tqty >= element.Qty){
        //         setItemPrice(element.Price);
        //     }
        // });
    }

    async function qtyChange(e){
        await setQty((!e.target.value || e.target.value=="" || e.target.value == isNaN)? 1: parseInt(e.target.value));
        if(qty < 1){
            setQty(1);
        }
        // props.prices.forEach(element => {
        //     let tqty = parseInt(e.target.value);
        //     if(tqty >= element.Qty){
        //         setItemPrice(element.Price);
        //     }
        // });
    }

    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }

    function addItem(){
        let address = {};
        if(!props.address || !props.address.Name){
            address={
                Name: "",
                Phone: "",
                Address: "",
                ZipCode: "",
                CityID: "",
                CityOngkirID: "",
                City: "",
                ProvinceID: "",
                Province: "",
                CountryID: "",
                Nation: "",
            };
        }else{
            address = props.address;
        }
        if(warehouse.Name && warehouse.Name != ""){
            props.setCart({
                ID: new Date()/1,
                PromoID: 0,
                PromoCode: "",
                PromoName: "",
                ItemID: props.item.ID,
                ItemUnitID: props.item.ItemUnitID,
                ItemName: props.itemname,
                ItemQty: qty,
                ItemUoM: "PCS",
                ItemPrice: props.itemprice,
                ItemWeight: props.itemweight,
                ItemColor: props.item.Color,
                ItemSize: props.item.Size,
                ImageName: props.imagename,
                Code: props.itemcode,
                IsChecked : 1,
                Stock: warehouse.Stock,
                WarehouseDetail:{
                    CompanyID: warehouse.CompanyID,
                    BranchID: warehouse.BranchID,
                    WarehouseID: warehouse.WarehouseID,
                    WarehouseName: warehouse.Name,
                    WarehousePhone: "",
                    WarehouseAddress: warehouse.Address,
                    WarehouseSubDistrict: "",
                    WarehouseCity: warehouse.CityName,
                    WarehouseCityID: warehouse.CityID,
                    WarehouseProvince: warehouse.ProvinceName,
                    WarehouseNation: "Indonesia",
                },
                ShippingMethod: shippingMethod,
                ExpeditionDetail: {
                    ExpeditionCode: "",
                    ExpeditionName: "",
                    ExpeditionFee: 0,
                },
                ShippingDetail: (shippingMethod == "PICKUP") ? {
                    ShippingDetailID: 1,
                    ShippingDetailName: "",
                    ShippingDetailPhone: "",
                    ShippingDetailAddress: "",
                    ShippingDetailZipCode: "0",
                    ShippingDetailSubDistrictID: "0",
                    ShippingDetailSubDistrict: "",
                    ShippingDetailCityID: "0",
                    ShippingDetailCity: "",
                    ShippingDetailProvinceID: "0",
                    ShippingDetailProvince: "",
                    ShippingDetailNationID: "0",
                    ShippingDetailNation: ""
                } 
                : {
                    ShippingDetailID: 0,
                    ShippingDetailName: address.Name,
                    ShippingDetailPhone: address.Phone,
                    ShippingDetailAddress: address.Address,
                    ShippingDetailZipCode: address.ZipCode,
                    ShippingDetailCityID: address.CityID,
                    ShippingDetailCityOngkirID: address.CityOngkirID,
                    ShippingDetailCity: address.City,
                    ShippingDetailProvinceID: address.ProvinceID,
                    ShippingDetailProvince: address.Province,
                    ShippingDetailNationID: address.CountryID,
                    ShippingDetailNation: address.Nation,
                }
            })
            props.changeIsOpenQty(false);
        }else{
            toast.error("No Warehouse Selected!")
        }
    }
    // useEffect(()=>{
    //     setWarehouses(props.warehouses);
    // },[props.warehouses]);

    useEffect(()=>{
        let el = document.getElementById("tabs");
        let options = {};
        var instance = M.Tabs.init(el, options);
        initWarehouse();
        initConfig();
    },[]);
    return (
        <>
            <Toaster
                position="bottom-center"
            />
            <div className="shipping-container">
                <div className="shipping-item-container">
                    <div className="shipping-flex-container">
                        <div className="shipping-item-image">
                            <img src={`${CMS_URL}/images/upload/product/${props.itemcode}/${props.imagename}`} />
                        </div>
                        <div className="shipping-item-detail">
                            <p className="detail-item-name">{props.itemname}</p>
                            <p className="detail-item-price">Rp {numberWithCommas((itemPrice === 0) ? props.itemprice : itemPrice)}</p>
                            <p style={{fontSize:"10pt"}}>Weight: {props.itemweight} kg</p>
                        </div>
                    </div>
                </div>
                <div className="shipping-flex-container" style={{alignItems:"center"}}>
                    <div className="shipping-flex-grow">Qty:</div>
                    <div className="detail-flex-item">
                        <button className="detail-rounded-btn" onClick={decrementQty}>-</button>
                    </div>
                    <div className="detail-flex-item" style={{textAlign:"center"}}>
                        <input type="text" value={qty} onChange={qtyChange} onKeyPress={qtyKeyPress}/>
                    </div>
                    <div className="detail-flex-item">
                        <button  className="detail-rounded-btn" onClick={incrementQty}>+</button>
                    </div>
                </div>
                <div className="shipping-flex-container">
                    <div className="shipping-flex-grow">Total Weight:</div>
                    <div><strong>{(props.itemweight * qty).toFixed(2)} Kg</strong></div>
                </div>
            </div>
            <div className="shipping-container">
                <div className="detail-header">Shipping Method</div>
                <div className="row">
                    <div className={`col s12`}>
                        <ul className="tabs" id="tabs">
                            <li className="tab col s6" onClick={ e=>{setShippingMethod("PICKUP")} }><a href="#test1">Pick up</a></li>
                            <li className="tab col s6" onClick={ e=>{setShippingMethod("SHIP BY")} }><a href="#test2">Delivery</a></li>
                        </ul>
                    </div>
                    <div id="test1" className="col s12">
                        <div className="shipping-flex-container" style={{display:"none"}}>
                            <div className="shipping-item-image" style={{display:"none"}}>
                                <img src={deliver} width={80} height={80}></img>
                            </div>
                            <div className="shipping-item-detail center">
                                <p className="detail-item-name">PICKUP</p>
                                <p style={{fontSize:"10pt"}}>Select the address where you like to pickup the package..</p>
                            </div>
                        </div>
                    </div>
                    <div id="test2" className="col s12">
                        {
                            (props.address)?(
                                <div className="shipping-info-container" style={{padding:"10px"}}>
                                    <div className="shipping-information-header">{props.address.Alias}</div>
                                    <div className="shipping-information-header">{props.address.Name}</div>
                                    <div>{props.address.Phone}</div>
                                    <div>{props.address.Address},{props.address.City},{props.address.Province},{props.address.Nation}</div>
                                </div>
                            ):(
                                <></>
                            )
                        }
                        {/* <hr/>
                        <div className="right-align">
                            <button className={`btn ${THEME_COLOR}`} onClick={()=> setIsOpenAddress(true)}>Change</button>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="shipping-container">
                <div className="detail-header">Warehouse</div>
                <div style={{marginBottom:"20px"}}>
                    <div className="shipping-info-container" style={{padding:"10px"}}>
                        <div className="shipping-information-header">{warehouse.Name}</div>
                        {
                            (availStockConfig.Value == 1) ?(
                                <div className="shipping-information-header">Stock: {warehouse.Stock}</div>
                            ):(<></>)
                        }
                        <div></div>
                        {(warehouse.CityName && warehouse.CityName != "") ? (
                            <div>{warehouse.Address}, {warehouse.CityName}, {warehouse.ProvinceName}, Indonesia</div>) : <></>}
                        <hr/>
                        <div className="right-align">
                            <button className={`btn ${THEME_COLOR}`} onClick={()=> setIsOpenWarehouse(true)}>Change</button>
                        </div>

                    </div>
                </div>
                <div style={{marginBottom:"40px"}}></div>
                <div style={{position:"fixed", bottom:"0", width: "100%", maxWidth:"480px", left:"0"}}>
                    <div className="shipping-footer white">
                        <div className="shipping-flex-grow">

                        </div>
                        <div className="shipping-footer-right" onClick={addItem}>
                            Add Item
                        </div>
                    </div>
                </div>
            </div>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenWarehouse}
                title="Choose Warehouse"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenWarehouse(false)}
            >
                <Warehouse
                    warehouses = {warehouses}
                    changeIsOpenWarehouse = {changeIsOpenWarehouse}
                    setWarehouse = {setWarehouse}
                />
            </SlidingPane>
        </>
    );
}

export default ItemInfo;